<template>
  <overlay-scrollbars id="katalog-scroll-container"
                      :options="{ className: 'content white custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <TheLoader :active="loading || updating" :update="updating"/>
    <section class="content large white">
      <table class="large fixed visible sticky-table-header compressed sortable" style="width: 100%">
        <thead>
        <tr>
          <th v-for="(heading, index) in headings" v-bind:key="index" v-bind:class="[heading.class, heading.sortKey === sortKey ? sortClass : '']" @click="sortBy(heading.sortKey)">
            {{heading.name}}
            <span id="sorttable_sortrevind" v-if="heading.sortKey === sortKey && !reverse">&nbsp;</span>
            <span id="sorttable_sortfwdind" v-if="heading.sortKey === sortKey && reverse">&nbsp;</span>
          </th>
        </tr>
        </thead>
        <tbody v-if="!loading && items.length < 1">
        <tr>
          <td colspan="7">
            <em>Fant ingen kunder...</em>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr v-for="item in items" v-bind:key="item.id">
          <td><a href="javascript:;" @click="loadObjektModal(item.Objektid)">{{ item.Objektnr }}</a></td>
          <td>{{ item.Beskrivelse }}</td>
          <td>{{ item.Kategori }}</td>
          <td>{{ item.full_name }}</td>
          <td>{{ item.Kundenr }}</td>
          <td>{{ item.expert_name }}</td>
          <td>{{ item.Auksjon }}</td>
          <td v-html="formatValue(item.Salgspris)"></td>
          <td v-html="formatDateMoment(item.Bokfortdato)"></td>
          <td v-html="formatDateMoment(item.Lagerleiedato)"></td>
          <td>{{ item.weeks }}</td>
        </tr>
        </tbody>
      </table>
      <br>
      <br>
      <div class="pagination-container" v-if="pages > 1" style="margin-top: -1rem;">
        <paginate v-model="params.page"
                  :page-count="pages"
                  :page-range="11"
                  :click-handler="setPage"
                  :container-class="'pagination'"
                  :prev-text="paginationArrow"
                  :next-text="paginationArrow"
                  :prev-class="'prev'"
                  :next-class="'next'"
        >
        </paginate>
      </div>
    </section>
  </overlay-scrollbars>
</template>

<script>
import ObjektService from '@/services/ObjektService'
import bus from '@/plugins/event-bus'
import moment from 'moment'
import accounting from 'accounting-js'
import Papa from 'papaparse'
import fileDownload from 'js-file-download'

export default {
  name: 'ObjectsPayingStorageList',
  data () {
    return {
      loading: false,
      updating: false,
      items: [],
      itemsExport: [],
      pages: 1,
      params: null,
      selected: [],
      headings: [
        {name: 'Objektnr', sortKey: 'Objektnr', class: ''},
        {name: 'Lokasjon', sortKey: 'Beskrivelse', class: ''},
        {name: 'Kategori', sortKey: 'Kategori', class: ''},
        {name: 'Kunde Navn', sortKey: 'full_name', class: ''},
        {name: 'Kundenr', sortKey: 'Kundenr', class: ''},
        {name: 'Ekspert', sortKey: 'expert_name', class: ''},
        {name: 'Auksjon', sortKey: 'Auksjon', class: ''},
        {name: 'Tilslag', sortKey: 'Salgspris', class: ''},
        {name: 'Betalt dato', sortKey: 'Bokfortdato', class: ''},
        {name: 'Lagerleiedato', sortKey: 'Lagerleiedato', class: ''},
        {name: 'Uker', sortKey: 'weeks', class: ''}
      ],
      sortKey: 'weeks',
      reverse: false
    }
  },
  created () {
    bus.$off('reload-kataloglist')
    bus.$off('export-kataloglist')
  },
  mounted () {
    bus.$on('reload-kataloglist', () => this.resetAndReload())
    bus.$on('export-kataloglist', () => this.exportCsv())
  },
  computed: {
    sortClass: function () {
      return 'sorttable_sorted' + (this.reverse ? '_reverse' : '')
    }
  },
  activated () {
    this.loading = true

    this.setDefaultParams()
    this.fetch()
  },
  methods: {
    setDefaultParams: function () {
      this.params = {
        page: 1,
        sort: 'weeks',
        direction: 'DESC',
        limit: 50,
        filterStorage: true
      }
    },
    resetAndReload: function () {
      this.updating = true
      this.$emit('onSubmitStatusChange', 'loading')
      this.setDefaultParams()
      this.fetch()
    },
    setPage: function (page) {
      let vm = this

      window.jQuery('.os-viewport', window.jQuery('#katalog-scroll-container')).animate({
        scrollTop: 0
      }, 200, function () {
        vm.updating = true
        vm.$emit('onSubmitStatusChange', 'loading')
        vm.fetch()
      })
    },
    fetch: function () {
      this.selected = []

      ObjektService.getObjectStoraged(this.params)
        .then((response) => {
          this.pages = parseInt(response.data[0].total)
          this.items = response.data
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn liste')
        })
        .then(() => {
          this.loading = false
          this.updating = false
          this.$emit('onSubmitStatusChange', 'submittable')
        })
    },
    formatDateMoment: function (date) {
      if (date) {
        let momentObj = moment(date, 'YYYY-MM-DD HH:mm:ss')
        return momentObj.format('DD.MM.YYYY')
      } else {
        return '---'
      }
    },
    formatValue: function (value) {
      if (value !== undefined && value !== null && value !== '') {
        return accounting.formatNumber(value, {precision: 0, thousand: ' '})
      }
      return '0'
    },
    sortBy: function (sortKey) {
      this.reverse = (this.sortKey === sortKey) ? !this.reverse : false
      this.sortKey = sortKey

      this.loading = true
      this.updating = true

      this.params.sort = sortKey
      this.params.direction = this.reverse ? 'ASC' : 'DESC'
      this.fetch()
    },
    exportCsv: function () {
      const params = this.params
      params.page = 1
      params.limit = 10000
      ObjektService.getObjectStoraged(params)
        .then((response) => {
          this.itemsExport = response.data
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn liste')
        })
        .then(() => {
          this.loading = false
          this.updating = false
          this.$emit('onSubmitStatusChange', 'submittable')

          const csv = '\ufeff' + Papa.unparse(this.itemsExport, { delimiter: ';' })
          const blob = new Blob([csv], {
            type: 'application/csvcharset=utf-8'
          })

          fileDownload(blob, 'Lagerleieliste-' + moment().format('DDMMYYHms') + '.csv')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Reports/ObjectsPayingStorageList.vue